import { Input } from 'antd';
import styled from 'styled-components';

const { TextArea: AntTextArea } = Input;

export const MultiLineInput = styled(AntTextArea)`
  && {
    background: transparent;
    border: 0;
    border-bottom: solid 1px transparent;
    box-shadow: none;
    font-size: inherit;
    line-height: inherit;
    resize: none;
    transition: none;

    &:hover,
    &:focus {
      border-bottom-color: var(--border-color);
    }
  }
`;
